import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Grid,
  Modal,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Paper,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import "./styles.scss";
import {
  getDateFormatedOrderTime,
  calculateOverSeasPrice,
  removeTimeFromOrderDate,
  truncateToTwoDecimals,
  getTempleNameById,
  getCityStateFromTemple,
} from "../../utils/HelperFunctions";
import {
  APPROLES,
  CAROUSEL_REMOVE_ARRAOW_ON_DEVICE,
  orderType,
  PUJA_PACKAGE_SCROLL_RESPONSIVE,
} from "../../utils/Constants";
import { LOCALIZATION } from "../../utils/localization";
import { t } from "i18next";
import InvoiceDownloadButton from "../InvoiceDownLoadButton/InvoiceDownLoadButton";
import Carousel from "react-multi-carousel";
import SingleChadavaPackageItem from "../SingleChadavaPackage/SingleChadavaPackageItem";
import ShowMoreShowLess from "../ShowMoreShowLess/ShowMoreShowLess";
import SubtitleTypographyPrimary from "../typography/SubtitleTypographyPrimary";
import { AppDispatch } from "../../store";
import { getSubOrdersOfaOrderAction } from "../../store/actions/orderAction";
interface Data {
  [key: string]: string;
}

interface ViewAllDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  orderId: string;
}

const ViewOrderDetailsModal: React.FC<ViewAllDetailsProps> = ({
  isOpen,
  onClose,
  orderId,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { userInfo } = useSelector((state: any) => state.user);
  const { userOrder } = useSelector((state: any) => state.order);
  const [orderDetails, setOrderDetails] = React.useState<any>({});
  const [expandedAccordion, setExpandedAccordion] = useState<string | null>(
    "panel-3"
  );
  const [subOrders, setSubOrders] = useState<any[]>([]);

  useEffect(() => {
    if (orderId && orderId.length > 0) {
      const orderDetailsArr = userOrder.filter(
        (item: any) => item.orderId == orderId
      );
      setOrderDetails(orderDetailsArr[0]);

      dispatch(getSubOrdersOfaOrderAction(orderDetailsArr[0]?.id))
      .then((res: any[]) => {
        const sortedSubOrders = [...(res || [])].sort((a, b) => {
          const aNum = Number(a.id.split("_").pop());
          const bNum = Number(b.id.split("_").pop());
          return aNum - bNum;
        });
        setSubOrders(sortedSubOrders);
      })
        .catch((err: any) => {});
    }
  }, [orderId, dispatch, userOrder]);

  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    if (
      userInfo &&
      (userInfo.userType === APPROLES.SUPERADMIN.roleId ||
        userInfo.userType === APPROLES.ADMIN.roleId)
    ) {
      setIsSuperAdmin(true);
    } else {
      setIsSuperAdmin(true);
      setExpandedAccordion("panel-3");
    }
  }, [userInfo]);

  const scrollRef: any = useRef(null);

  const scrollToBottom = () => {
    if (scrollRef.current) {
      //scrollRef.scrollIntoView({ behavior: "smooth" })
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    //scrollToBottom();
  }, [orderDetails]);

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : null);
      if (isExpanded) {
        scrollToBottom();
      }
    };

  const orderStatus = orderDetails?.orderStatus?.length
    ? orderDetails?.orderStatus[orderDetails?.orderStatus?.length - 1]
        ?.orderStatus
    : "";
  // Safe packageList initialization
  const packageItems = orderDetails?.pujaDetails?.packageItems;
  const packageList =
    packageItems && typeof packageItems === "object"
      ? Object.values(packageItems)
      : [];

  const subscriptionId = orderDetails?.subscriptionId;

  const filteredSubscription =
    Array.isArray(orderDetails?.pujaDetails?.subscriptions) ? orderDetails?.pujaDetails?.subscriptions?.find(
      (sub: any) => sub.id === subscriptionId
    ) : [] ;

  const subscriptionName = filteredSubscription?.name ?? orderDetails?.subscriptionPlan?.title ?? "";
  const subscriptionFrequency = filteredSubscription?.frequency || "";
  const subscriptionType = filteredSubscription?.type || "";


  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="change-status-title"
      className="orderModal"
    >
      <Box className="modalContents">
        <Stack className="modalHeader">
          <Typography id="change-status-title" variant="h6" gutterBottom>
            {t(LOCALIZATION.Order_id)} : <span> {orderId}</span>
          </Typography>

          <Button onClick={onClose} variant="outlined" className="btnClose">
            <CloseIcon />
          </Button>
        </Stack>

        <Box className="modalBody">
          <Box ref={scrollRef} className="orderDetails">
            <Grid container spacing={{ xs: 1, md: 2 }}>
              <Grid item xs={12} md={6} lg={4}>
                <Grid container direction="column" spacing={{ xs: 1, md: 2 }}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetails?.orderType === orderType.pujaPackage ||
                        orderDetails?.orderType === orderType.chadhavaPackage
                          ? t("Package_Name")
                          : t(LOCALIZATION.Temple_Name)}
                      </span>{" "}
                      :{" "}
                      {orderDetails?.orderType === orderType.pujaPackage ||
                      orderDetails?.orderType === orderType.chadhavaPackage
                        ? orderDetails?.pujaName
                        : orderDetails?.templeDetails?.name}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {orderDetails?.orderType === orderType.pujaPackage ||
                        orderDetails?.orderType === orderType.chadhavaPackage
                          ? t("Package_Type")
                          : t(LOCALIZATION.Puja_Name)}{" "}
                      </span>
                      :{" "}
                      {orderDetails?.orderType === orderType.pujaPackage ||
                      orderDetails?.orderType === orderType.chadhavaPackage
                        ? orderDetails?.orderType
                        : orderDetails?.orderType === orderType.puja
                        ? orderDetails?.pujaName
                        : orderDetails?.orderType === orderType.chadhava
                        ? "Chadhava"
                        : "Prasad"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {t(LOCALIZATION.Puja_Value)}
                      </span>{" "}
                      :{" "}
                      {orderDetails?.orderData?.currencySymbols
                        ? orderDetails?.orderData?.currencySymbols
                        : "₹"}
                      {/* { orderDetails?.orderData?.isOverseas ? calculateOverSeasPrice(orderDetails?.orderData?.payment?.orderValue,orderDetails?.orderData?.rate) : orderDetails?.orderData?.payment?.orderValue} */}
                      {orderDetails?.orderData?.isOverseas
                        ? orderDetails?.orderData?.payment?.orderValueOv
                          ? orderDetails?.orderData?.payment?.orderValueOv
                          : calculateOverSeasPrice(
                              orderDetails?.orderData?.payment?.orderValue,
                              orderDetails?.orderData?.rate
                            )
                        : orderDetails?.orderData?.payment?.orderValue}
                    </Typography>
                  </Grid>

                  {(orderDetails?.orderType === orderType.chadhava ||
                    orderDetails?.orderType === orderType.chadhavaPackage) &&
                    orderDetails?.orderData?.priceBreakup?.dakshina > 0 && (
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="body1">
                          <span style={{ fontWeight: "bold" }}>
                            {t(LOCALIZATION.Dakshina)}
                          </span>
                          :{" "}
                          {orderDetails?.orderData?.currencySymbols
                            ? orderDetails?.orderData?.currencySymbols
                            : "₹"}
                          {orderDetails?.orderData?.isOverseas
                            ? orderDetails?.orderData?.priceBreakup?.dakshinaOv
                              ? orderDetails?.orderData?.priceBreakup
                                  ?.dakshinaOv
                              : calculateOverSeasPrice(
                                  orderDetails?.orderData?.priceBreakup
                                    ?.dakshina,
                                  orderDetails?.orderData?.rate
                                )
                            : orderDetails?.orderData?.priceBreakup?.dakshina}
                        </Typography>
                      </Grid>
                    )}

                  {orderDetails?.orderType === orderType.prasad &&
                    orderDetails?.orderData?.delivaryWeightMl > 0 && (
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="body1">
                          <span style={{ fontWeight: "bold" }}>
                            {t(LOCALIZATION.Delivary_Weight_ml)}
                          </span>{" "}
                          :{" "}
                          {`${truncateToTwoDecimals(
                            orderDetails?.orderData?.delivaryWeightMl / 1000
                          )}`}
                        </Typography>
                      </Grid>
                    )}
                </Grid>
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <Grid container direction="column" spacing={{ xs: 1, md: 2 }}>
                  <Grid item xs={12} md={6} lg={4}>
                    {isSuperAdmin && (
                      <Typography variant="body1">
                        <span style={{ fontWeight: "bold" }}>
                          {t(LOCALIZATION.Order_Status)}{" "}
                        </span>{" "}
                        :{" "}
                        {orderDetails?.orderStatus?.length
                          ? orderDetails?.orderStatus[
                              orderDetails?.orderStatus?.length - 1
                            ]?.orderStatus
                          : ""}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {t(LOCALIZATION.Order_User_Name)}{" "}
                      </span>{" "}
                      : {orderDetails?.orderUserDetails?.orderUserName}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {t(LOCALIZATION.Phone_Number)}{" "}
                      </span>{" "}
                      :{" "}
                      {orderDetails?.deliveryAddress?.phoneNumber &&
                      orderDetails.deliveryAddress.phoneNumber.length > 3
                        ? orderDetails?.deliveryAddress?.phoneNumber
                        : orderDetails?.orderUserDetails?.phoneNumber}
                    </Typography>
                  </Grid>
                  {orderDetails?.orderType === orderType.prasad &&
                    orderDetails?.orderData?.deliveryWeightGrams > 0 && (
                      <Grid item xs={12} md={6} lg={4}>
                        <Typography variant="body1">
                          <span style={{ fontWeight: "bold" }}>
                            {t(LOCALIZATION.Delivary_Weight_gram)}
                          </span>{" "}
                          :{" "}
                          {`${truncateToTwoDecimals(
                            orderDetails?.orderData?.deliveryWeightGrams / 1000
                          )}`}
                        </Typography>
                      </Grid>
                    )}
                </Grid>
              </Grid>

              <Grid item xs={12} md={6} lg={4}>
                <Grid container direction="column" spacing={{ xs: 1, md: 2 }}>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {t(LOCALIZATION.WhatsApp_number)}{" "}
                      </span>{" "}
                      :{" "}
                      {orderDetails?.whatsAppNumberdialCode
                        ? orderDetails?.whatsAppNumberdialCode
                        : "+91"}{" "}
                      {orderDetails?.whatsAppNumber}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    <Typography variant="body1">
                      <span style={{ fontWeight: "bold" }}>
                        {t(LOCALIZATION.Booked_on)}{" "}
                      </span>{" "}
                      :{" "}
                      {getDateFormatedOrderTime(orderDetails?.orderBookingDate)}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={4}>
                    {![
                      orderType.prasad,
                      orderType.chadhavaPackage,
                      orderType.pujaPackage,
                    ].includes(orderDetails.orderType) && (!orderDetails?.isSubscribed) && (
                      <Typography variant="body1">
                        <span style={{ fontWeight: "bold" }}>
                          {t(LOCALIZATION.Booked_for)}{" "}
                        </span>{" "}
                        : {removeTimeFromOrderDate(orderDetails?.pujaDate)}
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {((orderDetails?.orderType === orderType.puja &&
                orderDetails?.orderData?.isPrasad) ||
                orderDetails?.orderType === orderType.prasad) && (
                <Grid item xs={12} md={12} lg={12}>
                  {[orderType.puja, orderType.prasad]?.includes(
                    orderDetails?.orderType
                  ) &&
                    orderDetails?.deliveryAddress && (
                      <Typography variant="body1">
                        <span style={{ fontWeight: "bold" }}>
                          {t(LOCALIZATION.Delivery_address)}
                          {""}
                        </span>{" "}
                        :
                        {`${orderDetails?.deliveryAddress?.street},${
                          orderDetails?.deliveryAddress?.area || " "
                        },${orderDetails?.deliveryAddress?.city},${
                          orderDetails?.deliveryAddress?.state
                        },${orderDetails?.deliveryAddress?.zip}`}
                      </Typography>
                    )}
                </Grid>
              )}
              {orderDetails?.orderType === orderType.prasad &&
                (orderDetails?.orderData?.deliveryWeightGrams > 10000 ||
                  orderDetails?.orderData?.delivaryWeightMl > 1000) && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#ca5261",
                        fontWeight: "bold",
                        lineHeight: 0.8,
                      }}
                    >
                      {t(LOCALIZATION.Over_Weight_Message)}
                    </Typography>
                  </Grid>
                )}
            </Grid>

            {(orderDetails?.orderType === orderType.pujaPackage ||
              orderDetails?.orderType === orderType.chadhavaPackage) &&
              orderDetails?.orderData?.isPrasad &&
              orderDetails?.deliveryAddress && (
                <Grid item xs={12} className="infoDetailsList">
                  <Typography variant="body1">
                    <span style={{ fontWeight: "bold" }}>
                      Delivery Address{" "}
                    </span>{" "}
                    :{" "}
                    {`${orderDetails.deliveryAddress.street}, ${
                      orderDetails.deliveryAddress.area || ""
                    }, ${orderDetails.deliveryAddress.city}, ${
                      orderDetails.deliveryAddress.state
                    }, ${orderDetails.deliveryAddress.zip}`}
                  </Typography>
                </Grid>
              )}

            {(orderDetails?.orderType === orderType.pujaPackage ||
              orderDetails?.orderType === orderType.chadhavaPackage || orderDetails?.orderType === orderType.chadhava || orderDetails?.orderType === orderType.puja) &&
              orderDetails?.isSubscribed && (
                <Grid item xs={12} className="infoDetailsList">
                  <Typography variant="body1">
                    <span style={{ fontWeight: "bold" }}>
                      {" "}
                      Subscribed{" "}
                    </span>{" "}
                    : {subscriptionName} {subscriptionFrequency}
                    {subscriptionType}
                  </Typography>
                </Grid>
              )}

            {packageList.length > 0 && (
              <Box
                className="packageoverViewText"
                id="puja-overview"
                sx={{ mb: 2 }}
              >
                <SubtitleTypographyPrimary
                  title={
                    orderDetails?.orderType === orderType.pujaPackage
                      ? t("Item_Included_In_This_Puja_Package")
                      : orderDetails?.orderType === orderType.chadhavaPackage
                      ? t("Item_Included_In_This_Chadhava_Package")
                      : "Item Included in this Package"
                  }
                />
              </Box>
            )}

            <Box className="productCardCarousel">
              {packageList.length > 0 && (
                <Carousel
                  responsive={PUJA_PACKAGE_SCROLL_RESPONSIVE}
                  swipeable
                  draggable
                  showDots
                  infinite
                  keyBoardControl
                  containerClass="carousel-container"
                  itemClass="carousel-item-padding-40"
                  removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
                >
                  {packageList.map((pkg: any) => {
                    let imageUrl =
                      pkg.multiPujaImg?.[1]?.pictureUrl ?? pkg.pujaBg?.uri;

                    if (orderDetails?.orderType === orderType.chadhavaPackage) {
                      imageUrl = pkg?.image;
                    }

                    const templeName = getTempleNameById(
                      orderDetails?.pujaDetails?.templeList,
                      pkg.orgId
                    );
                    const templeList =
                      orderDetails?.pujaDetails?.templeList || {};
                    const personalInfo =
                      templeList?.[pkg?.orgId]?.personalInfo || {};

                    const templeAddress = getCityStateFromTemple(personalInfo);

                    return (
                      <div
                        key={pkg.id}
                        style={{
                          cursor: "pointer",
                          margin: "0 auto",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          overflow: "hidden",
                        }}
                      >
                        <SingleChadavaPackageItem
                          packageImage={imageUrl}
                          packageName={
                            orderDetails?.orderType === orderType.pujaPackage
                              ? pkg?.pujaName
                              : pkg?.name
                          }
                          templeName={<span>{templeName}</span>}
                          templeAddress={templeAddress}
                        />
                      </div>
                    );
                  })}
                </Carousel>
              )}
            </Box>

            <Divider sx={{ opacity: 0.6, paddingBottom: "5px" }} />

            <Grid item xs={12} md={6}>
              {orderDetails?.isSubscribed
                ? (() => {
                    const subscriptionDesc =
                      orderDetails?.pujaDetails?.subscriptions?.[0]
                        ?.description;
                    return (
                      <Box className="bottomDescription">
                        {subscriptionDesc && (
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: 500,
                              mb: 0.5,
                              color: "primary.main",
                            }}
                          >
                            {t(LOCALIZATION.Subscription_Description)}
                          </Typography>
                        )}
                        <ShowMoreShowLess
                          text={subscriptionDesc || ""}
                          limit={120}
                        />
                      </Box>
                    );
                  })()
                : (() => {
                    const packageDesc =
                      orderDetails?.pujaDetails?.packageDescription;
                    return (
                      <Box className="bottomDescription">
                        {packageDesc && (
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontWeight: 500,
                              mb: 0.5,
                              color: "primary.main",
                            }}
                          >
                            {t(LOCALIZATION.Package_Description)}
                          </Typography>
                        )}
                        <ShowMoreShowLess
                          text={packageDesc || ""}
                          limit={120}
                        />
                      </Box>
                    );
                  })()}
            </Grid>

            <Box className="accordionList">
              {[orderType.chadhava, orderType.prasad]?.includes(
                orderDetails?.orderType
              ) && (
                <>
                  <Accordion
                    sx={{ boxShadow: "none" }}
                    expanded={expandedAccordion === `panel-4`}
                    onChange={handleChange("panel-4")}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{ padding: "0px 16px" }}
                    >
                      <Typography variant="body1">
                        <span style={{ fontWeight: "bold" }}>
                          {orderDetails?.orderType === orderType.puja
                            ? orderDetails?.pujaName
                            : orderDetails?.orderType === orderType.chadhava
                            ? t(LOCALIZATION.Chadhava_Item_List)
                            : t(LOCALIZATION.Prasad_Item_List)}
                        </span>
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <TableContainer component={Paper}>
                        <Table aria-label="chadhavalist">
                          <TableHead>
                            <TableRow>
                              <TableCell className="tableHeaderCell">
                                {orderDetails?.orderType === orderType.puja
                                  ? orderDetails?.pujaName
                                  : orderDetails?.orderType ===
                                    orderType.chadhava
                                  ? t(LOCALIZATION.Chadhava_Image)
                                  : t(LOCALIZATION.Prasad_Image)}
                              </TableCell>
                              <TableCell className="tableHeaderCell">
                                {orderDetails?.orderType === orderType.puja
                                  ? orderDetails?.pujaName
                                  : orderDetails?.orderType ===
                                    orderType.chadhava
                                  ? t(LOCALIZATION.Chadhava_Item)
                                  : t(LOCALIZATION.Prasad_Item)}
                              </TableCell>
                              {orderDetails?.orderType === orderType.prasad && (
                                <TableCell className="tableHeaderCell">
                                  {t(LOCALIZATION.Package)}
                                </TableCell>
                              )}
                              <TableCell className="tableHeaderCell">
                                {t(LOCALIZATION.Qty)}.
                              </TableCell>
                              <TableCell className="tableHeaderCell">
                                {t(LOCALIZATION.Price)}
                                {`(${
                                  orderDetails?.orderData?.currencySymbols
                                    ? orderDetails?.orderData?.currencySymbols
                                    : "₹"
                                })`}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {orderDetails?.chadhavaList?.map(
                              (el: any, index: number) => {
                                let selPkg = "-";
                                if (
                                  el?.selectedPackageId &&
                                  el?.packages?.length
                                ) {
                                  const foundPkg = el.packages.find(
                                    (_itm: any) =>
                                      _itm.packageId === el.selectedPackageId
                                  );
                                  if (foundPkg) {
                                    selPkg = `${foundPkg?.value} ${foundPkg?.measurement}`;
                                  }
                                }
                                return (
                                  <TableRow key={index}>
                                    <TableCell>
                                      <img
                                        width="50px"
                                        height="50px"
                                        src={el.image}
                                        alt=""
                                      ></img>
                                    </TableCell>
                                    <TableCell>{el?.name}</TableCell>
                                    {orderDetails?.orderType ===
                                      orderType.prasad && (
                                      <TableCell>{selPkg}</TableCell>
                                    )}
                                    <TableCell>{el?.count}</TableCell>
                                    <TableCell>
                                      {" "}
                                      {orderDetails?.orderData?.isOverseas
                                        ? truncateToTwoDecimals(
                                            calculateOverSeasPrice(
                                              el.priceInfo?.finalPrice,
                                              orderDetails?.orderData?.rate
                                            ) as any
                                          )
                                        : truncateToTwoDecimals(
                                            el.priceInfo?.finalPrice
                                          )}
                                    </TableCell>
                                  </TableRow>
                                );
                              }
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </AccordionDetails>
                  </Accordion>
                </>
              )}
              <Accordion
                sx={{ boxShadow: "none" }}
                expanded={expandedAccordion === `panel-3`}
                onChange={handleChange("panel-3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ padding: "0px 16px" }}
                >
                  <Typography variant="body1">
                    <span style={{ fontWeight: "bold" }}>
                      {t(LOCALIZATION.Puja_Members_Details)}
                    </span>
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer component={Paper}>
                    <Table aria-label="puja-member-details-table">
                      <TableHead>
                        <TableRow>
                          <TableCell className="tableHeaderCell">
                            {t(LOCALIZATION.Full_Name)}
                          </TableCell>
                          <TableCell className="tableHeaderCell">
                            {t(LOCALIZATION.Gotram)}
                          </TableCell>
                          <TableCell className="tableHeaderCell">
                            {t(LOCALIZATION.Puja_Name)}
                          </TableCell>
                          <TableCell className="tableHeaderCell">
                            {t(LOCALIZATION.Manokamna_Wish)}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {orderDetails?.orderUserDetails?.groupDetails?.map(
                          (member: any, index: number) => (
                            <TableRow key={index}>
                              <TableCell>{member.fullName}</TableCell>
                              <TableCell>
                                <TableCell>
                                  {orderDetails?.orderType !== orderType.prasad
                                    ? member.gotram || ""
                                    : ""}
                                </TableCell>
                              </TableCell>
                              <TableCell>
                                {" "}
                                {orderDetails?.pujaName?.trim().length > 0
                                  ? orderDetails?.pujaName
                                  : orderDetails?.orderType ===
                                    orderType.chadhava
                                  ? "Chadhava"
                                  : "Prasad"}
                              </TableCell>
                              <TableCell>
                                {member?.additionalDetails || member?.manokamna}
                              </TableCell>
                            </TableRow>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            </Box>

            {orderDetails?.isSubscribed &&
              subOrders?.length > 0 && (
                <Box sx={{ mt: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                      color: "primary.main",
                      fontSize: "18px",
                    }}
                  >
                    Sub Orders
                  </Typography>

                  <Grid container spacing={2} >
                    {subOrders?.map((sub: any, index: number) => {
                      const subOrderItems = Object.values(
                        sub?.subOrderItems || {}
                      );

                      return (
                        <Grid item xs={12} key={index}>
                          <Card
                            elevation={3}
                            sx={{
                              borderRadius: "16px",
                              boxShadow: "none",
                              border: "1px solid #eee",
                              background: "#fafafa",
                              p: "16px 12px",
                              // minHeight: "300px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <CardContent sx={{ flex: "0 0 auto", p: "0" }}>
                              <Typography
                                variant="body1"
                                sx={{ fontWeight: 500, color: "#464646" }}
                              >
                                Sub Order ID:{" "}
                                <span
                                  style={{ fontWeight: 600, color: "#000" }}
                                >
                                  {sub?.id}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  mt: 0.5,
                                  color: "#464646",
                                  fontWeight: 500,
                                }}
                              >
                                Order Status:{" "}
                                <span
                                  style={{ fontWeight: 600, color: "#000" }}
                                >
                                  {sub?.lastStatus}
                                </span>
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{
                                  mt: 0.5,
                                  color: "#464646",
                                  fontWeight: 500,
                                }}
                              >
                                Puja Date:{" "}
                                <span
                                  style={{ fontWeight: 600, color: "#000" }}
                                >
                                  {removeTimeFromOrderDate(sub?.pujaDate)}
                                </span>
                              </Typography>
                            </CardContent>

                            {subOrderItems.length > 0 && (
                              <Box sx={{ mt: 0.1, flex: "1 1 auto" }}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    fontWeight: 500,
                                    mb: 1,
                                    mt: 1,
                                    color: "primary.main",
                                    fontSize: "16px",
                                  }}
                                >
                                  Item Included in this Sub Order
                                </Typography>

                                <Box className="productCardCarousel">
                                  <Carousel
                                    responsive={PUJA_PACKAGE_SCROLL_RESPONSIVE}
                                    swipeable
                                    draggable
                                    showDots
                                    infinite
                                    keyBoardControl
                                    containerClass="carousel-container"
                                    itemClass="carousel-item-padding-40"
                                    removeArrowOnDeviceType={
                                      CAROUSEL_REMOVE_ARRAOW_ON_DEVICE
                                    }
                                  >
                                    {subOrderItems.map((item: any) => {
                                      let imageUrl =
                                        item.multiPujaImg?.[0]?.pictureUrl ??
                                        item.pujaBg?.uri;
                                      if (
                                        orderDetails?.orderType ===
                                        orderType.chadhavaPackage
                                      ) {
                                        imageUrl = item?.image;
                                      }

                                      const templeName = getTempleNameById(
                                        sub.templeList,
                                        item.orgId
                                      );
                                      const personalInfo =
                                        sub.templeList?.[item?.orgId]
                                          ?.personalInfo || {};
                                      const templeAddress =
                                        getCityStateFromTemple(personalInfo);

                                      return (
                                        <div
                                          key={item.id}
                                          style={{
                                            cursor: "pointer",
                                            margin: "0 auto",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <SingleChadavaPackageItem
                                            packageImage={imageUrl}
                                            packageName={
                                              item.pujaName || item.name
                                            }
                                            templeName={
                                              <span>{templeName}</span>
                                            }
                                            templeAddress={templeAddress}
                                          />
                                        </div>
                                      );
                                    })}
                                  </Carousel>
                                </Box>
                              </Box>
                            )}
                          </Card>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              )}
          </Box>
        </Box>

        <Box className="modalFooter">
          <InvoiceDownloadButton
            orderData={orderDetails?.orderId}
            isDownload={true}
          />
          <Button
            onClick={onClose}
            variant="outlined"
            className="btnCancel grey"
          >
            {t(LOCALIZATION.Close)}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewOrderDetailsModal;
